import { ManagementInsight, ManagementQuote } from '@toggle/toggle';
import { differenceInHours } from 'date-fns';
import React from 'react';

import { ManagementQuotes } from './management-quotes/ManagementQuotes';
import styles from './ManagementCommentarySection.module.scss';
import { StrategicInsights } from './strategic-insights/StrategicInsights';

interface ManagementCommentarySectionProps {
  managementInsights: ManagementInsight[];
  quotes: ManagementQuote[];
  createdAt: string;
}

export const ManagementCommentarySection = ({
  managementInsights,
  createdAt,
  quotes,
}: ManagementCommentarySectionProps) => {
  const createdAtDate = new Date(createdAt);
  const now = new Date();
  const hoursDifference = differenceInHours(now, createdAtDate, {
    roundingMethod: 'round',
  });
  const isMoreThan24HoursAgo = hoursDifference > 24;
  const shouldHideQuotes = isMoreThan24HoursAgo && quotes.length === 0;

  return (
    <div className={styles.root}>
      <StrategicInsights managementInsights={managementInsights} />
      {!shouldHideQuotes && <ManagementQuotes quotes={quotes} />}
    </div>
  );
};
